import * as firebase from 'firebase/app';
import 'firebase/firestore';
//import Firestore = firebase.firestore.Firestore;

import { ShaqFAQ } from '@/models/Objects';
import FirebaseService from '@/services/FirebaseService';
import Firestore = firebase.firestore.Firestore;

export default class FirestoreService {
  private static instance: FirestoreService;
  private db: Firestore;
  private readonly faqsCollection: string = 'faqs';

  static getInstance () {
    if (!FirestoreService.instance) {
      FirestoreService.instance = new FirestoreService();
    }
    return FirestoreService.instance;
  }

  private constructor () {
    let app  = FirebaseService.getAppInstance();
    this.db = app.firestore();
  }

  getFAQ (): ShaqFAQ {
    this.db.collection(this.faqsCollection).doc("1").get()
    .then(doc => {
      if (!doc.exists) {
        console.log('No such document!');
      } else {
        console.log('Document data:', doc.data());
      }
    })
    .catch(err => {
      console.log('Error getting document', err);
    });

    let shaqFAQ = new ShaqFAQ();
    shaqFAQ.question = 'What is a Shaq';
    shaqFAQ.answer = 'God\'s gift';
    return shaqFAQ;
  }

  /*  getFAQ(): ShaqFAQ{
      let shaqFAQ = new ShaqFAQ();
      shaqFAQ.question = "What is a Shaq";
      shaqFAQ.answer = "God's gift";
      return shaqFAQ
    }*/
}